
import React from "react";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { Outlet } from 'react-router-dom';

function IndexPage(props){
    return <div id={'page'} className="min-vh-100 d-flex flex-column justify-content-around">
        <Header />

        <main className={'m-0'}>

            {props.children}

            <Outlet />

        </main>

        <Footer />
    </div>
}

export default IndexPage;